// src/hooks/useUserRole.js
import { useContext } from 'react';
import { AuthContext } from '../utils/AuthContext';

const SUPERADMIN_EMAIL = 'perevozki0968884440@gmail.com';

export default function useUserRole() {
  const { user } = useContext(AuthContext);

  if (!user) {
    return {
      role: null,
      loading: false,
    };
  }

  return {
    role:
      user.email === SUPERADMIN_EMAIL
        ? 'superadmin'
        : user.role || 'user',
    loading: false,
  };
}
